import type { FC } from 'react'
import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { OneTooltip, OneInput } from '@yy/one-ui'
import { HelpCircle } from '@yy/one-icon'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'
import RULES from '../../../../../rules'
import styles from './index.module.less'

interface InnerInputProps {
  required?: boolean
  value?: any
  onChange?(value: any): void
  placeholder?: string
}

const InnerInput: React.FC<InnerInputProps> = (props) => {
  const { required, value, onChange, ...restProps } = props
  /**
   * 必须为必填且默认为空才生成
   * 生成规则跟后端一样，8位数字无需考虑重复问题
   */
  useEffect(() => {
    // 后端异步返回 null，只能通过判断 null 自动填写
    if (required && !value && typeof onChange === 'function') {
      onChange(Math.floor(Math.random() * 1e8).toString())
    }
  }, [required, value, onChange])

  return <OneInput value={value} onChange={onChange} {...restProps} />
}

export interface IProps {
  defaultValue?: string
  required?: boolean
}

export const InvoiceNoField: FC<IProps> = (props) => {
  const { defaultValue, required = false } = props
  const { t } = useTranslation()
  const label = useMemo(() => {
    const label = `${t('provider.invoice_no')}${required ? '' : t('logistics.create.optional')}`
    return (
      <>
        {label}
        <OneTooltip title={t('InvoiceNoField.tooltips')} overlayClassName={styles.tooltip}>
          <HelpCircle className={styles.tooltipIcon} />
        </OneTooltip>
      </>
    )
  }, [t, required])

  return (
    <FormItem
      name="provider_invoice_no"
      initialValue={defaultValue}
      label={label}
      required={required}
      rules={RULES.provider_invoice_no({
        isRequired: required,
      })}
    >
      <InnerInput required={required} placeholder={t('common.input.placeholder')} />
    </FormItem>
  )
}
